import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

/**
 * Индикатор версии SEO-конфига. Читает `configVersion` из модели (его отдаёт
 * `/seo/settings`, без отдельного HTTP-запроса). Нет версии — индикатор скрыт.
 */
@Component({
  selector: 'app-seo-version-info',
  standalone: false,
  template: `
    @if (version != null) {
      <div class="d-flex align-items-center flex-wrap gap-2 mb-3 small text-muted">
        <span class="badge rounded-pill bg-light text-muted fw-semibold" i18n="@@SeoConfigVersion">версия #{{ version }}</span>
        <span i18n="@@SeoAppliedWithin">· применяется на сайте в течение ~60 секунд</span>
      </div>
    }
  `,
})
export class SeoVersionInfoComponent extends FieldType {
  get version(): number | null {
    return (this.model as {configVersion?: number} | undefined)?.configVersion ?? null;
  }
}
